var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "#D6E5E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.317 26.435l5.795-10.239 1.75-4.16s2.685-.575 2.685 2.842-1.725 9.1-1.725 10.047c0 .947 1.297 2.355 4.759 2.355 3.462 0 6.613.243 7.222 2.38.402 1.46-.596 2.164-.661 3.47 0 .703.544 1.28.713 1.945.274.96.157 1.989-.324 2.867-.39.652-1.206 1.01-1.491 1.728-.428 1.036.583 1.817.544 2.802 0 1.51-2.152 2.048-2.035 3.443.064.858.142 2.368-.882 2.727C45.642 49 35.1 49 33.507 49c-1.596 0-4.876-1.011-4.954-3.302V31.619a1.556 1.556 0 00-.448-1.16 1.596 1.596 0 00-1.16-.478h-7.222c-1.711 0-1.711.755-1.711 1.69v15.166s-.247 1.51 1.53 1.51h6.885",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
export default SvgThumbsUp;